import React from 'react';
export function Footer() {
  return <footer className="w-full py-8 border-t" style={{
    borderColor: 'var(--color-border)',
    backgroundColor: 'var(--color-cream)'
  }} data-id="element-60">
      <div className="max-w-3xl mx-auto px-4 text-center space-y-3" data-id="element-61">
        <p className="font-handwritten text-2xl" style={{
        color: 'var(--color-brown)'
      }} data-id="element-62">
          Napftagebuch
        </p>
        <p className="text-xs leading-relaxed max-w-md mx-auto" style={{
        color: 'var(--color-text-light)'
      }} data-id="element-63">
          Dieser Beitrag basiert auf meiner persönlichen Erfahrung. Ergebnisse
          können individuell variieren. Bei anhaltenden gesundheitlichen
          Problemen deines Hundes konsultiere bitte einen Tierarzt.
        </p>
        <p className="text-xs" style={{
        color: 'var(--color-text-light)'
      }} data-id="element-64">
          Produkt von{' '}
          <a href="https://hunderunde.shop" target="_blank" rel="noopener noreferrer" className="underline hover:no-underline" style={{
          color: 'var(--color-green)'
        }} data-id="element-65">
            hunderunde.shop
          </a>
        </p>
      </div>
    </footer>;
}